export const currency = (n: number, d: number = 2) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencySign: 'accounting',
    minimumFractionDigits: d,
    maximumFractionDigits: d
  }).format(n);

export const rate = (n: number, d: number = 2) => {
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: d,
    maximumFractionDigits: d
  }).format(Math.abs(n));
  return n < 0 ? `(${formatted}%)` : `${formatted}%`;
};
